module.exports = __webpack_public_path__ + "media/images/favicon/android-chrome-384x384-966862262ca28056a5c027784ab71a06.png";